import styled from 'styled-components';

const StyledWell = styled.div`
  min-height: 20px;
  padding: 19px;
  background-color: #f5f5f5;
  border-radius: 4px;
  width: 100%;
`
export default StyledWell;